import script from "./nyTit1.vue?vue&type=script&setup=true&lang=js"
export * from "./nyTit1.vue?vue&type=script&setup=true&lang=js"

import "./nyTit1.vue?vue&type=style&index=0&id=6ebf51ff&lang=less&scoped=true"
script.__scopeId = "data-v-6ebf51ff"

export default script